import installationInstructions from './installationInstructions';

const peaPlugContent = {
  installationInstructions
}

export { peaPlugContent };
